export const NOTIFICATION = "NOTIFICATION";
export const NOTIFICATION_ITEM = "NOTIFICATION_ITEM";
export const SNACKBAR = "SNACKBAR";